import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TranslationType } from "../types";

interface NameFieldProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: any;
  t: TranslationType;
  defaultValue?: string;
  userName?: string;
  lockedFirstName?: boolean;
  lockedLastName?: boolean;
}

export const NameField = ({
  register,
  errors,
  t,
  defaultValue,
  userName,
  lockedFirstName = false,
  lockedLastName = false,
}: NameFieldProps) => {
  // userName is an alias for defaultValue when provided
  const resolvedDefault = userName ?? defaultValue;
  // Parse defaultValue into first and last names
  const getInitialNames = () => {
    if (!resolvedDefault) return { firstName: "", lastName: "" };
    const parts = resolvedDefault.trim().split(/\s+/);
    return {
      firstName: parts[0] || "",
      lastName: parts.slice(1).join(" ") || "",
    };
  };

  const { firstName: initialFirstName, lastName: initialLastName } =
    getInitialNames();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="firstName">{t.firstName}</Label>
        <Input
          id="firstName"
          {...register("firstName", { required: true })}
          className={
            lockedFirstName
              ? "bg-gray-50 text-gray-500 cursor-default select-none"
              : errors.firstName
                ? "border-red-500"
                : ""
          }
          defaultValue={initialFirstName}
          autoComplete="given-name"
          readOnly={lockedFirstName}
        />
        {errors.firstName && !lockedFirstName && (
          <span className="text-sm text-red-500">{t.firstNameRequired}</span>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="lastName">{t.lastName}</Label>
        <Input
          id="lastName"
          {...register("lastName", { required: true })}
          className={
            lockedLastName
              ? "bg-gray-50 text-gray-500 cursor-default select-none"
              : errors.lastName
                ? "border-red-500"
                : ""
          }
          defaultValue={initialLastName}
          autoComplete="family-name"
          readOnly={lockedLastName}
        />
        {errors.lastName && !lockedLastName && (
          <span className="text-sm text-red-500">{t.lastNameRequired}</span>
        )}
      </div>
    </div>
  );
};
